import React from 'react';
import { Timer } from 'lucide-react';
export function AnnouncementBar() {
  return <div className="sticky top-0 z-50 w-full bg-gray-900 text-white py-2.5 px-4 shadow-md" data-id="element-19">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 text-sm md:text-base font-medium" data-id="element-20">
        <Timer className="w-4 h-4 text-rose-400 animate-pulse" data-id="element-21" />
        <span data-id="element-22">
          <span className="text-rose-400 font-bold" data-id="element-23">OFERTA ESPECIAL:</span> 50%
          OFF + 6 Bonos Gratis. Termina pronto.
        </span>
      </div>
    </div>;
}